import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UserNotification } from "@edp-models/user-notification.model";
import { Observable } from "rxjs";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { getActiveTabMenu } from "@edp-store/selectors/layout.selectors";
@Component({
    selector: "edp-e-notification-card",
    templateUrl: "./edp-e-notification-card.component.html",
    styleUrls: ["./edp-e-notification-card.component.scss"],
})
export class EdpENotificationCardComponent {
    @Input() card: UserNotification;
    @Output() clicked: EventEmitter<any> = new EventEmitter();

    public activeFilter$: Observable<string>;
    constructor(private store: Store<IAppState>) {
        this.activeFilter$ = this.store.pipe(select(getActiveTabMenu));
    }

    public onClick() {
        this.clicked.emit();
    }
}
